const GenderType = {
  OTHER: 3,
  FEMALE: 2,
  MALE: 1
}
export default GenderType
